import { useState } from 'react';

import api from '@/app/services/axios.service';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

function PasswordReset() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [error, setError] = useState('');

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (!email) return;

    try {
      setStatus('loading');
      setError('');
      await api.post('/users/password-reset', { email });
      setStatus('success');
    } catch (err: unknown) {
      const maybeError = err as { response?: { data?: { message?: string } } };
      setError(maybeError?.response?.data?.message ?? 'Failed to send reset link');
      setStatus('error');
    }
  }

  return (
    <div className="flex items-center justify-center w-full min-h-screen px-4 bg-background font-[Inter] text-black">
      <div className="w-full max-w-md space-y-8">
        <img
          src="/icons/brand/revi/monogram-black.svg"
          alt="revi-logo"
          className="mx-auto size-10"
        />
        <div className="flex flex-col items-center space-y-2 text-center">
          <h1 className="text-2xl font-bold tracking-tight">Reset your password</h1>
          {status !== 'success' && (
            <p className="text-sm font-normal text-muted-foreground">
              Enter your email and we'll send you a reset link
            </p>
          )}
        </div>

        {status === 'success' ? (
          <div className="flex flex-col items-center space-y-2 text-center">
            <p className="text-sm text-center">Success! Check your email for a reset link.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                className="h-12"
              />
            </div>
            {status === 'error' && <p className="px-2 text-xs text-destructive">{error}</p>}
            <Button className="w-full h-12 font-semibold" disabled={status === 'loading'}>
              {status === 'loading' ? 'Sending...' : 'Send reset link'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}

export default PasswordReset;
